<template>
    <v-app id="layout-login">
        <v-app-bar app color="primary" dark>
            <v-toolbar-title>{{ $t('app.name') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <select-language-component/>
        </v-app-bar>
        <v-main>
            <snackbar-component/>
            <v-container fill-height fluid>
                <slot/>
            </v-container>
        </v-main>
        <footer-partial/>
    </v-app>
</template>

<script>
    import FooterPartial from "@/partials/FooterPartial";
    import SnackbarComponent from "@/components/layout/SnackbarComponent";
    import SelectLanguageComponent from "@/components/layout/SelectLanguageComponent";

    export default {
        name: 'LayoutLogin',
        components: {SelectLanguageComponent, SnackbarComponent, FooterPartial},
        data: () => ({})
    }
</script>
